import { User } from 'app/javascript/components/graphql'

export const createdByFormatter = (isPublicView: boolean, createdBy: User) => {
  return `${createdBy.firstName ? createdBy.firstName : ''} ${
    !isPublicView && createdBy.lastName ? createdBy.lastName : ''
  }`
}
